import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import { UploadPremiumEmojiContent } from './common/update-emoji-content'

import type { PairModel } from '@root/entities/pair'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'open' | 'onOpenChange'> & {
  pair: PairModel
}

export const UploadPremiumEmojiDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  pair,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      title={t('premium.update-emoji.title')}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Content
        currency={pair.quote}
        premiumMeta={pair.premiumInfo}
        onClose={() => {
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(Drawer)`
  display: grid;
`

const Content = styled(UploadPremiumEmojiContent)`
  padding-bottom: var(--safe-bottom);
`
